import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import StarIcon from '@mui/icons-material/Star';
import {
  Box,
  Button,
  DialogActions,
  Stack,
  Tooltip,
  // List,
  // ListItem,
  // ListItemText,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import useClipboard from 'react-use-clipboard';

import { useBasicExitIntent } from '@/hooks/useBasicExitIntent';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ExitPopup941 = () => {
  const [open, setOpen] = useState(false);

  useBasicExitIntent(() => {
    setOpen(true);
  });

  const handleClose = () => {
    sessionStorage.setItem('tzo-exit-intent', 'exit');
    setOpen(false);
  };
  const [isCopied, setCopied] = useClipboard('FIRSTSTUB ', {
    successDuration: 6000,
  });
  const [isCopied1, setCopied1] = useClipboard('TZO10OFF ', {
    successDuration: 6000,
  });
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="holiday-theme"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
      />
      <DialogContent>
        <Box component="div" sx={{ textAlign: 'center', mt: 0 }}>
          {/* Header Section with Image + Title */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 2, sm: 3 }}
            alignItems="center"
            justifyContent="center"
            sx={{ px: { xs: 1, sm: 3 }, mb: 2 }}
          >
            <Box
              component="img"
              src="/assets/images/wait-img.png"
              loading="lazy"
              alt="Wait! Before You Go!"
              width={130}
              height={106}
            />

            <Box
              sx={{ textAlign: { xs: 'center', sm: 'left' }, maxWidth: 400 }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, md: 30 },
                  color: '#da4b4b',
                  lineHeight: 1.3,
                }}
              >
                Experience a Free Paystub –{' '}
                <span style={{ color: '#606060ff' }}>
                  Try It Before You Buy
                </span>
              </Typography>
            </Box>
          </Stack>

          {/* Coupon Section */}
          <Box
            sx={{
              mx: 'auto',
              mb: 2,
              maxWidth: 500,
              p: 2,
              border: '2px dashed rgb(113, 81, 0)',
              backgroundColor: 'rgb(255, 250, 205)',
              borderRadius: 2,
              fontSize: { xs: 12, sm: 14, md: 16 },
              fontWeight: 400,
              lineHeight: 1.5,
              textAlign: 'center',
            }}
          >
            Create your first paystub free and see how simple it really is—use
            code{' '}
            <Box
              component="strong"
              sx={{
                color: '#fd5345',
                fontWeight: 600,
                fontSize: { xs: 18, sm: 20, md: 22 },
              }}
            >
              FIRSTSTUB
            </Box>
            <Tooltip title={isCopied ? 'Copied' : 'Copy to Clipboard'} arrow>
              <IconButton onClick={setCopied} sx={{ ml: 1 }}>
                <ContentCopyIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
            <br />
            As a Taxzerone user, enjoy a{' '}
            <span style={{ fontWeight: 600 }}>special 10% discount</span> on
            future paystubs with code{' '}
            <Box
              component="strong"
              sx={{
                color: '#fd5345',
                fontWeight: 600,
                fontSize: { xs: 18, sm: 20, md: 22 },
              }}
            >
              TZO10OFF
            </Box>
            <Tooltip title={isCopied1 ? 'Copied' : 'Copy to Clipboard'} arrow>
              <IconButton onClick={setCopied1} sx={{ ml: 1 }}>
                <ContentCopyIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: '24px !important',
          textAlign: 'center',
          backgroundColor: '#f9f9f9',
          borderTop: '1px solid #ccc',
        }}
      >
        <Box sx={{ px: { xs: 1, sm: 3 }, mt: 1 }}>
          <Button
            variant="contained"
            size="large"
            // className="btn-primary"
            sx={{
              textTransform: 'none',
              boxShadow: 'none',
              borderRadius: 4,
              display: 'inline-block',
              fontSize: { xs: 18, sm: 20, md: 22, lg: 24 },
            }}
            href="https://app.securepaystubs.com/paystub/?utm_source=TZO&utm_medium=popup"
          >
            Generate My <span style={{ color: '#eaff00' }}> Free Paystub</span>
          </Button>
        </Box>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ExitPopup941;
